module.exports = __webpack_public_path__ + "static/img/19.be0e532.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rootDoc/img/19.png
// module id = PBgz
// module chunks = 1